import { render, staticRenderFns } from "./ladder-promotion.vue?vue&type=template&id=1e3f87c2&scoped=true"
import script from "./ladder-promotion.vue?vue&type=script&lang=js"
export * from "./ladder-promotion.vue?vue&type=script&lang=js"
import style0 from "./ladder-promotion.vue?vue&type=style&index=0&id=1e3f87c2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3f87c2",
  null
  
)

export default component.exports